<template>
    <b-modal :id='"modal-carousel"+id' size="md" title="Preview Foto" @shown="focusInputSubmit" no-close-on-esc no-close-on-backdrop>
      <template>
            <div>
                <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
                >
      
                  <b-carousel-slide v-for="(x, index) in foto"
                  :key="index"
                  :img-src='$companyId == "PGI" ?$baseFilePath + x.name :x.name'
                  ></b-carousel-slide>
        
                </b-carousel>
            </div>
        </template>          
    </b-modal>
</template>


<script>
  export default {
  props: {
    foto: {type: Array},
    id: {type: Number}
  },
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      }
    }
  }
</script>